export function VerifiedBadge({ show, size = 20, testId = "verified-badge" }) {
  if (!show) return null;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} role="img" aria-label="Ligue vérifiée" data-testid={testId}
      className="inline-block shrink-0 align-[-0.12em]">
      <title>Ligue d'entreprise vérifiée par Ma Petite Ligue</title>
      <path fill="#1D9BF0" d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
      <path d="m8.6 12.2 2.3 2.3 4.6-4.8" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
